import React from 'react';
import './transfer.css';
import axios from 'axios';

export function Transfer() {

    const onTransfer = (e) => {
        e.preventDefault();

        const srcId = e.target.srcId.value;
        const destId = e.target.destId.value;
        const amount = parseFloat(e.target.amount.value);

        console.log(`Source ${srcId} Destination ${destId} Amount ${amount}`);
        axios('https://www.tigerbank.store/transfer', {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ srcId, destId, amount })
        })
        .then(json =>{
            console.log(json)
        })
        .catch(error =>{
            console.error('데이터 요청이 실패하였습니다.',error)
        })
    }

    return (
        <div className="trnCont">
            <div className="p--section">
                <h1> 계좌이체 </h1>
                <form onSubmit={onTransfer}>
                    <input type='number' placeholder='출금 계좌 번호' name='srcId' />
                    <input type='number' placeholder='입금 계좌 번호' name='destId' />
                    <input type='number' placeholder='금액' name='amount' />
                    <input type='submit' value='이체' />
                </form>
            </div>
        </div>
    );
}

export default Transfer;
